frappe.provide("frappe.phone_call");

frappe.ui.form.ControlMeasureUnit = class ControlMeasureUnit extends frappe.ui.form.ControlData {
	static html_element = "input";
	static input_type = "text";
	static trigger_change_on_input_event = true;


	static _digitalDataCache = frappe.boot.measureUnit;

	getFloatValue() {
		return parseFloat(this.format_for_input(this.value)[0])
	}

	getUnitValue() {
		return this.format_for_input(this.value)[1]
	}

	make_input() {

		if (this.$input) return;

		let { html_element, input_type } = this.constructor;

		this.$input = $('<div>')
			.addClass('input-group')
			.prependTo(this.input_area);

		// Create text input
		this.$input_text = $("<input>") // Assuming input_type is text
			.attr("type", "text")
			.attr("autocomplete", "off")
			.addClass("input-with-feedback form-control")
			.appendTo(this.$input);

		// Create select input
		this.$input_select = $("<select>")
			.addClass("form-control")
			.appendTo(this.$input);


		// Check and populate the digital data cache
		if (!Object.keys(ControlMeasureUnit._digitalDataCache).length) {
			let me = this; // Correct 'this' context for the callback
			frappe.xcall("ftcore.utils.utils.get_all_data", {
				target_doc: "Measure unit",
				fields: ['*'],
				filters: {},
			}).then(response => {
				const measure_units = response;
				measure_units.forEach(unit_data => {
					ControlMeasureUnit._digitalDataCache[unit_data.description] = unit_data.digitals;
				});

				// Populate select options
				Object.keys(ControlMeasureUnit._digitalDataCache).forEach(unit => {
					me.$input_select.append(new Option(unit, unit));
				});
				me.set_input(this.value);

				// Additional logic to set the select value if needed
			});
		} else {
			// Populate select options from cache if already loaded
			Object.keys(ControlMeasureUnit._digitalDataCache).forEach(unit => {
				this.$input_select.append(new Option(unit, unit));
			});
			this.set_input(this.value);

		}



		this.$input_text.on("paste", (e) => {
			let pasted_data = frappe.utils.get_clipboard_data(e);
			let maxlength = this.$input_text.attr("maxlength");
			if (maxlength && pasted_data.length > maxlength) {
				let warning_message = __(
					"The value you pasted was {0} characters long. Max allowed characters is {1}.",
					[cstr(pasted_data.length).bold(), cstr(maxlength).bold()]
				);

				// Only show edit link to users who can update the doctype
				if (this.frm && frappe.model.can_write(this.frm.doctype)) {
					let doctype_edit_link = null;
					if (this.frm.meta.custom) {
						doctype_edit_link = frappe.utils.get_form_link(
							"DocType",
							this.frm.doctype,
							true,
							__("this form")
						);
					} else {
						doctype_edit_link = frappe.utils.get_form_link(
							"Customize Form",
							"Customize Form",
							true,
							null,
							{
								doc_type: this.frm.doctype,
							}
						);
					}
					let edit_note = __(
						"{0}: You can increase the limit for the field if required via {1}",
						[__("Note").bold(), doctype_edit_link]
					);
					warning_message += `<br><br><span class="text-muted text-small">${edit_note}</span>`;
				}

				frappe.msgprint({
					message: warning_message,
					indicator: "orange",
					title: __("Data Clipped"),
				});
			}
		});

		this.set_input_attributes();
		this.input = this.$input.get(0);
		this.has_input = true;
		this.bind_change_event();

		this.$input_text.on('input', function () {
			// Replace any non-digit characters with an empty string
			// Allows digits and one dot for decimal values
			$(this).val($(this).val().replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
		});

	}

	bind_change_event() {
		const change_handler = (e) => {
			if (this.change) this.change(e);
			else {
				// Combine the values from text input and select input
				let combinedValue = this.get_combined_value();

				// Update the value in the model
				this.parse_validate_and_set_in_model(combinedValue, e);
			}
		};
		this.$input_text.on("change", change_handler);
		this.$input_select.on("change", change_handler);
		if (this.constructor.trigger_change_on_input_event && !this.in_grid()) {
			// debounce to avoid repeated validations on value change
			this.$input_text.on("input", frappe.utils.debounce(change_handler, 500));
			this.$input_select.on("input", frappe.utils.debounce(change_handler, 500));
		}
	}

	get_combined_value() {
		let textValue = this.$input_text.val() || "";
		let selectValue = this.$input_select.val() || "";
		return textValue + ' ' + selectValue; // Combine them with a space or any other delimiter
	}

	set_input_attributes() {
		if (
			in_list(
				["Data", "Link", "Dynamic Link", "Password", "Select", "Read Only"],
				this.df.fieldtype
			)
		) {
			if (this.frm?.meta?.issingle) {
				// singles dont have any "real" length requirements
				return;
			}
			this.$input.attr("maxlength", this.df.length || 140);
		}

		this.$input
			.attr("data-fieldtype", this.df.fieldtype)
			.attr("data-fieldname", this.df.fieldname)
			.attr("placeholder", this.df.placeholder || "");
		if (this.doctype) {
			this.$input.attr("data-doctype", this.doctype);
		}
		if (this.df.input_css) {
			this.$input.css(this.df.input_css);
		}
		if (this.df.input_class) {
			this.$input.addClass(this.df.input_class);
		}
	}
	set_input(value) {

		this.last_value = this.value;
		this.value = value;
		this.set_formatted_input(value);
		this.set_disp_area(value);
		this.set_mandatory && this.set_mandatory(value);
	}


	set_formatted_input(value) {

		const values = this.format_for_input(value)
		this.$input && this.$input_text && this.$input_text.val(values[0]);

		this.$input && this.$input_select && this.$input_select.val(values[1]);
	}

	get_input_value() {
		let values = [0, 'Each'];

		// Corrected syntax for conditional assignments
		if (this.$input && this.$input_text) {
			values[0] = this.$input_text.val();
		}
		if (this.$input && this.$input_select) {
			values[1] = this.$input_select.val();
		}

		// Return value based on the existence of this.$input
		return values;
	}

	format_for_input(val) {
		function determineValueType(val) {
			if (!isNaN(val)) {
				// It's a number (integer or float)
				if (val.includes('.')) {
					return 'float';
				} else {
					return 'integer';
				}
			} else {
				// It's a non-numeric string
				return 'string';
			}
		}

		if (!val) {
			return [0, ""]
		}
		val = String(val)

		let firstSpaceIndex = val.indexOf(' ');
		if (firstSpaceIndex === -1) {

			if (determineValueType(val) == "string") {
				return [0, val]

			}
			else {
				return [parseFloat(val).toFixed(0), "Each"]

			}

		}

		let firstPart = val.substring(0, firstSpaceIndex); // Gets the first word
		let restOfTheString = val.substring(firstSpaceIndex + 1); // Gets the rest of the string

		let temp_result = [firstPart, restOfTheString];

		temp_result[1] = temp_result[1] ? temp_result[1] : ""

		if (temp_result[1]) {
			temp_result[0] = temp_result[0] ? parseFloat(temp_result[0]).toFixed(ControlMeasureUnit._digitalDataCache[temp_result[1]]) : 0
		}

		return temp_result

	}
	validate(v) {
		let temp_result = this.format_for_input(v);
		this.df.invalid = temp_result[1] == ""

		if (!v) {
			return "";
		}
		return v;
	}

	toggle_container_scroll(el_class, scroll_class, add = false) {
		let el = this.$input.parents(el_class)[0];
		if (el) $(el).toggleClass(scroll_class, add);
	}
	in_grid() {
		return this.grid || (this.layout && this.layout.grid);
	}
};

